<template>
  <v-dialog :value="value" @input="$emit('input', false)" max-width="500px" persistent>
    <v-card dark rounded="xl">
      <v-toolbar flat dense dark color="grey darken-3">
        <v-toolbar-title class="font-weight-bold">Weiterleiten an...</v-toolbar-title>
      </v-toolbar>

      <v-text-field
        v-model="searchQuery"
        placeholder="Gruppen suchen..."
        filled
        rounded
        dense
        hide-details
        dark
        clearable
        prepend-inner-icon="mdi-magnify"
        class="pa-3"></v-text-field>

      <v-list dark color="transparent" style="max-height: 40vh; overflow-y: auto">
        <v-list-item-group v-model="selectedGroupIds" multiple>
          <v-list-item v-for="group in filteredGroups" :key="group._id" :value="group._id" class="mb-1 glass-card" rounded="lg">
            <v-list-item-avatar color="grey darken-2" class="mr-3">
              <v-img v-if="group.bild" :src="group.bild"></v-img>
              <v-icon v-else dark>mdi-account-group</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ group.name }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-checkbox :input-value="selectedGroupIds.includes(group._id)" color="primary"></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-card-actions class="pa-4">
        <v-btn text @click="$emit('input', false)">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded depressed large :disabled="selectedGroupIds.length === 0" @click="sendForward">
          Senden ({{ selectedGroupIds.length }})
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex"
export default {
  name: "ForwardMessageDialog",
  props: ["value", "message"], // 'value' (v-model), 'message' (die wir weiterleiten)

  data() {
    return {
      searchQuery: "",
      selectedGroupIds: [], // Hält die IDs der Ziel-Gruppen
    }
  },

  computed: {
    ...mapState("chatStore", ["chatGroups"]), // Holt ALLE Gruppen

    filteredGroups() {
      const query = this.searchQuery.toLowerCase().trim()
      if (!query) return this.chatGroups

      return this.chatGroups.filter((g) => g.name.toLowerCase().includes(query))
    },
  },

  methods: {
    ...mapActions("chatStore", ["forwardMessage"]),

    getGroupInitials(name) {
      /* ... (Kopier es aus ChatGroupList.vue) ... */
    },

    sendForward() {
      this.forwardMessage({
        message: this.message,
        targetGroupIds: this.selectedGroupIds,
      })
      // Aufräumen & Schließen
      this.selectedGroupIds = []
      this.searchQuery = ""
      this.$emit("input", false)
    },
  },
}
</script>

<style lang="scss" scoped>
/* (Kopier die '.glass-card'-Styles aus ChatGroupList.vue hierher) */
.glass-card {
  background-color: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  transition: all 0.2s ease-out;
}
</style>
